import { Component, ReactNode } from 'react';
import ErrorBox from './ErrorBox';

export default class ErrorBoundary extends Component<
  { children: ReactNode },
  { error: any }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: unknown) {
    return { error };
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return <ErrorBox error={error} p={3} />;
    }

    return children;
  }
}
